import React, { useEffect } from "react";
import Apps from "../views/Apps";
import { Box, Typography } from "@mui/material";
import PageTitle from "../base/PageTitle";
import { useDispatch, useSelector } from "../../store";
import { useNavigate } from "react-router-dom";

interface Props {}

const AppsPage: React.FC<Props> = (props) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const { selectedCompany, allowedCompanies } = useSelector(
    (store) => store.company
  );
  const { appLoaded, globalLoadingState } = useSelector(
    (store) => store.shared
  );
  const { enabledApplications } = useSelector((store) => store.application);

  useEffect(() => {
    if (
      !!appLoaded.companyList &&
      !!appLoaded.dbUser &&
      !selectedCompany?.finishedSetup
    ) {
      if (!selectedCompany && allowedCompanies?.length > 1) {
        navigate("/select");
      } else {
        navigate("/setup");
      }
    }
  }, [
    navigate,
    dispatch,
    allowedCompanies,
    selectedCompany,
    appLoaded.companyList,
    appLoaded.dbUser,
  ]);

  return !globalLoadingState.isLoading ? (
    <Box visibility={enabledApplications?.length > 1 ? "visible" : "hidden"}>
      <PageTitle title="Select Application" />
      <Box
        display="flex"
        flexDirection="row"
        justifyContent="center"
        alignContent="center"
        justifyItems="center"
        alignItems="center"
        paddingBottom={3}
      >
        <Typography variant="h4" textAlign="center">
          Choose a product below to explore its full capabilities and take your
          security management to the next level!
        </Typography>
      </Box>
      <Apps />
    </Box>
  ) : (
    <></>
  );
};

export default AppsPage;
